function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "9E6FB6EF-9962-484C-A4BF-25F7D39597E5");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Styleguide-+-UI-Components",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Styleguide",
  transform: "translate(-590.000000, -6555.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon_Manage",
  transform: "translate(590.000000, 6555.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#FFFFFF",
  opacity: 0,
  x: 0,
  y: 0,
  width: 60,
  height: 60
}), /*#__PURE__*/React.createElement("g", {
  id: "Mint_assets_Icon",
  transform: "translate(1.000000, 1.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M29,58 C45.0181478,58 58,45.0181513 58,29 C58,12.9847501 45.0181478,0 29,0 C12.984731,0 0,12.9847501 0,29 C0,45.0167028 12.984731,58 29,58 L29,58 Z",
  id: "Oval_6_",
  fill: "#1D4C56"
}), /*#__PURE__*/React.createElement("g", {
  id: "Shape",
  transform: "translate(8.704248, 22.612708)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M37.6463689,0 C36.9982316,0 3.43795302,0 3.25090645,0 C1.45579681,0 0,1.46159916 0,3.25090082 L0,27.6268515 C0,29.2131533 1.17303618,30.6776508 2.73614039,30.9285027 L38.1596303,30.9285027 C39.7256104,30.6762018 40.8986908,29.2117044 40.8986908,27.6268515 C40.8986908,26.8134001 40.8986908,3.98749993 40.8986908,3.25090082 C40.8986908,1.46159916 39.440018,0 37.6463689,0 L37.6463689,0 Z",
  stroke: "#1D9682",
  strokeWidth: 1.45,
  fill: "#1D9682"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.2080124,27.6326483 C39.2080124,28.5925473 38.4235839,29.3769976 37.4636579,29.3769976 L3.43361665,29.3769976 C2.47373502,29.3769976 1.68926239,28.5925473 1.68926239,27.6326483 L1.68926239,3.40749776 C1.68926239,2.44759961 2.47369079,1.66314907 3.43361665,1.66314907 L37.4636579,1.66314907 C38.4235391,1.66314907 39.2080124,2.44759961 39.2080124,3.40749776 L39.2080124,27.6326483 L39.2080124,27.6326483 Z",
  fill: "#1D716C"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(18.801147, 33.090869)",
  fill: "#1DEBB4"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000, 3.428887)",
  id: "Shape"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.15816798,8.89140549 C0.863813788,8.89140549 0.566583249,8.77830691 0.340374743,8.55210392 C-0.113458244,8.09825431 -0.113458244,7.36310401 0.340374743,6.90925441 L6.91033317,0.339301697 C7.12782388,0.12179947 7.423639,0 7.73104717,0 L7.73104717,0 C8.03991491,0 8.33422509,0.124697879 8.55176045,0.342200098 L11.7431941,3.54814793 C12.1941509,4.00199754 12.1941509,4.73714757 11.7373975,5.18809878 C11.2835648,5.64194839 10.5513072,5.63904999 10.0974298,5.18520038 L7.72666629,2.80284793 L1.97742151,8.55209809 C1.75267325,8.77830691 1.45544276,8.89140549 1.15816798,8.89140549 L1.15816798,8.89140549 Z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(9.825201, 0.000000)",
  id: "Shape"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.16108852,8.89104595 C0.860937522,8.89104595 0.563706941,8.77794771 0.33749846,8.55174486 C-0.113458252,8.09644565 -0.113458252,7.3627448 0.3432953,6.90889553 L6.9480345,0.338942153 C7.40186794,-0.114907461 8.13412479,-0.112009053 8.58800187,0.341840569 C9.04183531,0.797139417 9.03895885,1.53084013 8.58508178,1.98179138 L1.98034205,8.55464314 C1.75267336,8.77794188 1.45544285,8.89104595 1.16108852,8.89104595 L1.16108852,8.89104595 Z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(9.858168, 0.001101)",
  id: "Shape"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.73140073,8.88994522 C7.08906077,8.88994522 6.56995843,8.37229764 6.56995843,7.73139579 L6.56995843,2.31999785 L1.15856622,2.31999785 C0.519102472,2.31999785 0,1.79944611 0,1.1585497 C0,0.517653277 0.517642179,0 1.15856622,0 L7.73140073,0 C8.37086448,0 8.88996735,0.517647746 8.88996735,1.1585497 L8.88996735,7.73140109 C8.88996735,8.37084311 8.37232484,8.88994522 7.73140073,8.88994522 L7.73140073,8.88994522 Z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(13.973596, 7.137604)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.5599831,3.18202481 C14.3172905,-1.06067591 7.41819677,-1.06067591 3.17984024,3.18202481 C-1.05997625,7.42182428 -1.05997625,14.320924 3.17984024,18.5621723 C7.41965648,22.8019718 14.3187509,22.8019718 18.5599831,18.5621723 C22.7998003,14.3194739 22.7998003,7.42182751 18.5599831,3.18202481 L18.5599831,3.18202481 Z",
  id: "Shape",
  stroke: "#1DCDA2",
  strokeWidth: 1.45,
  fill: "#1DCDA2"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(1.735637, 1.739277)",
  fill: "#1DA88D",
  id: "Circle"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 9.13354969,
  cy: 9.13354969,
  r: 9.13354969
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(7.918713, 7.923324)",
  fill: "#1DEBB4",
  id: "Shape"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.426043703,9.57745115 C0.0722610455,9.22365184 -0.0887222251,8.69730298 0.0490295381,8.17820063 C0.256387323,7.40245113 1.05099334,6.94279888 1.8252883,7.15015164 C3.32312294,7.54890376 4.93264594,7.11970157 6.0274033,6.02639931 C7.12069998,4.9301985 7.55134584,3.32214672 7.15114449,1.82430102 C6.9437863,1.05144968 7.40346037,0.258301159 8.1792157,0.0509516699 C8.94917451,-0.159298984 9.7451964,0.300352942 9.95255398,1.07610273 C10.6210013,3.57155375 9.90179855,6.25260187 8.07770483,8.07670143 C6.25361173,9.90080038 3.5696426,10.6170992 1.07710109,9.95155029 C0.820448309,9.88340425 0.601496853,9.75290441 0.426043703,9.57745115 L0.426043703,9.57745115 Z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(3.623141, 3.625390)",
  fill: "#1DEBB4",
  id: "Shape"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.618090809,9.76898375 C0.442637626,9.59353594 0.312142943,9.37313535 0.243997193,9.11793192 C-0.42157441,6.62537943 0.297628794,3.94433074 2.11884613,2.12023166 C3.93426678,0.307731705 6.60226136,-0.41436709 9.08608533,0.233780846 C9.86184088,0.438231945 10.3243915,1.2313804 10.1228302,2.0042317 C9.91839316,2.77998147 9.12524694,3.24398101 8.35236832,3.04098184 C6.8632064,2.64948129 5.25952448,3.08303099 4.17202456,4.17343219 C3.07872774,5.26673459 2.64516132,6.87478047 3.04536272,8.37118244 C3.2527206,9.1440342 2.79304664,9.9400834 2.01729124,10.1474304 C1.49969337,10.2837388 0.971917748,10.1227885 0.618090809,9.76898375 L0.618090809,9.76898375 Z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(8.692743, 8.694928)",
  fill: "#1DCDA2",
  id: "Circle"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 2.17645007,
  cy: 2.17645007,
  r: 2.17645007
})))))));

var SvgIconManage = function SvgIconManage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconManage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Icon_Manage.9a5fd49c.svg";
export { ForwardRef as ReactComponent };